/*
 * The user's location: the switch in the header while the option `header` is on.
 * The front-end manifest, see lib/docs/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';
import { extensionOption } from '@lib/utils/eflib';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'user_location',
	locale: { de, en },
	slots: {
		header: [
			{
				id: 'user_location',
				when: () => extensionOption('user_location', 'header'),
				component: () => import('./components/HeaderLocation.vue'),
			},
		],
	},
});
